// @flow
import React from 'react';
import { createUseStyles } from 'react-jss';
import {
  FONT_FAMILY_ROBOTO
} from 'shared/constants';

export type Title = {
  color_theme: 'DARK' | 'LIGHT',
  title: string,
  title_font: string,
  title_font_size: string,
  title_opacity: string,
  title_line_height: string,
  title_font_weight: string,
  content_padding_top: string,
  title_padding_left_right: string,
  title_position: string,
}

type Props = {
  titleProps: Title
}

export default function CTABlock(props: Props){
  const { titleProps } = props;
  const { title = '' } = titleProps;
  const c: { [key: string]: string } = useStyles(titleProps);

  // Prevent empty component from blocking user interaction
  if (!title) {
    return null;
  }

  return (
    <div className={c.cta}>
      <div className={c.title}>
        {title}
      </div>
    </div>
  );
}

const useStyles = createUseStyles({
  cta: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    position: 'absolute',
    top: ({ content_padding_top }) => content_padding_top ? content_padding_top : '30%',
    left: '0',
    right: '0',
    alignItems: 'center'
  },
  title: {
    color: ({ color_theme }) => color_theme === 'LIGHT' ? 'black' : 'white', // default 'DARK'
    fontFamily: ({ title_font }) => title_font ? title_font : FONT_FAMILY_ROBOTO,
    fontSize: ({ title_font_size }) => `${title_font_size || '60'}px`,
    padding: ({ title_padding_left_right }) => `0px ${title_padding_left_right || '0px'}`,
    textAlign: ({ title_position }) => title_position || 'center',
    opacity: ({ title_opacity }) => title_opacity || '1',
    lineHeight: ({ title_line_height }) => title_line_height || 'normal',
    fontWeight: ({ title_font_weight }) => title_font_weight || '400',
    width: '100%',
    alignItems: 'center',
    letterSpacing: '1.5px',
    whiteSpace: 'pre-line',
    transition: 'all .6s ease-in-out',
    transitionDelay: '.4s',
    '@media(max-width: 960px)': {
      fontSize: '28px'
    }
  },
});
